import React from "react";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Education } from "@/components/landing/Education";
import { Professional } from "@/components/landing/Professional";
import { AppGallery } from "@/components/landing/AppGallery";
import { CardDiscovery } from "@/components/landing/CardDiscovery";
import { Travel } from "@/components/landing/Travel";
import { Security } from "@/components/landing/Security";
import { Stats } from "@/components/landing/Stats";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="bg-[#FAFAF7] text-[#0A0A0A] font-sans antialiased">
      <Header />
      <Hero />
      <HowItWorks />
      <Education />
      <Stats />
      <Professional />
      <AppGallery />
      <CardDiscovery />
      <Travel />
      <Security />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
